import React, { useCallback, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import ExportLoadingModal from "Components/Common/ExportLoadingModal";
import { exportCapacityAssessmentsToCsv } from "common/services/capacity-assessments.service";
import Permission from "Components/Common/Permission";
import { toast } from "react-toastify";
import CapacityAssessmentsImportModal from "./CapacityAssessmentsImportModal";

const Import = ({ apiParams }: { apiParams?: any }) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const [exporting, setExporting] = useState(false);
  const getCsvExport = useCallback(async () => {
    setExporting(true);

    await exportCapacityAssessmentsToCsv({
      filters: apiParams.filters,
      sort: apiParams.sort,
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Capacity_Assessments_Export.csv");
        link.click();
        link.remove();
      })
      .catch((error: any) => {
        toast.error("An error occurred while exporting capacity assessments.");
      });

    setExporting(false);
  }, [apiParams]);
  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          className="btn btn-light"
          id="dropdownMenuButton"
        >
          <i className="ri ri-more-fill"></i>
        </DropdownToggle>
        <DropdownMenu>
          <Permission resource="capacity-assessment" action="import">
            <DropdownItem
              onClick={() => {
                setIsImportModalOpen(true);
              }}
            >
              <i className="ri ri-upload-2-line me-1"></i>
              Import
            </DropdownItem>
          </Permission>
          <Permission resource="capacity-assessment" action="exportToCsv">
            <DropdownItem
              onClick={() => {
                getCsvExport();
              }}
            >
              <i className="ri ri-download-2-line me-1"></i>
              Export
            </DropdownItem>
          </Permission>
        </DropdownMenu>
      </UncontrolledDropdown>

      <CapacityAssessmentsImportModal
        toggle={() => setIsImportModalOpen(!isImportModalOpen)}
        isOpen={isImportModalOpen}
      />
      <ExportLoadingModal show={exporting} onCloseClick={() => {}} />
    </>
  );
};

export default Import;
